import axios from "axios";
import config from "@/config";

export const BACKEND = axios.create({
  baseURL: config.remotes.backend,
  auth: {
    username: config.remotes.username,
    password: config.remotes.password,
  },
});

export const WORDPRESS = axios.create({
  baseURL: "https://xn----stbeziy.xn--p1ai/wp-admin/admin-ajax.php",
});

export const U_BACKEND = axios.create({
  baseURL: config.remotes.backend,
  auth: {
    username: config.remotes.username,
    password: config.remotes.password,
  },
});

export const NEW_BACKEND = axios.create({
  baseURL: config.new_remotes.url,
});
export const NAME_ORGANITHATION = axios.create({
  baseURL: config.organithation.url,
  headers: {
    Authorization: "token " + config.organithation.token,
  },
});
export const ADDRESS = axios.create({
  baseURL: config.address.url,
  headers: {
      Authorization: "Token " + config.address.token,
  },
});

export const NEWEST_BACKEND = axios.create({
  baseURL: config.newest_remotes.url,
  auth: {
    username: config.remotes.username,
    password: config.remotes.password,
  },
});